import {
  CheckIcon,
  LabRequisition,
  ModalDialog,
  Mtds,
  SaveError,
  XIcon
} from 'prove-common'
import { useState } from 'react'
import { useAnalysisCompletedMutation } from '../../hooks/useRequisitionsForLab'

type CompleteSampleModalProps = {
  isOpen: boolean
  setOpen: (isOpen: boolean) => void
  requisition: LabRequisition
}

export const CompleteSampleModal = ({
  isOpen,
  setOpen,
  requisition
}: CompleteSampleModalProps) => {
  const analysisCompleted = useAnalysisCompletedMutation()
  const [error, setError] = useState<unknown>(null)
  const onSubmit = (): void => {
    setError(null)
    analysisCompleted
      .mutateAsync(requisition.id)
      .then(() => {
        Mtds.toast.success(
          'Analysis completion reported; sample ready for assessment'
        )
        setOpen(false)
      })
      .catch((error) => {
        setError(error)
      })
  }
  return (
    <ModalDialog
      id='complete-sample-modal'
      closedby='any'
      open={isOpen}
      onClose={() => {
        setError(null)
        setOpen(false)
      }}
    >
      <Mtds.Button
        command='close'
        commandfor={'complete-sample-modal'}
        aria-label={'Close'}
      />
      <Mtds.Prose>
        <Mtds.Heading>Confirm completion</Mtds.Heading>
        <p>
          Confirm that the analysis for sample{' '}
          <strong># {requisition.sampleId}</strong> is complete. All
          non-dismissed subsamples must have results before the sample can be
          finalized by the inspector.
        </p>
        <form
          onSubmit={(event) => {
            event.preventDefault()
            onSubmit()
          }}
          className={'flex flex-col gap-8'}
        >
          <SaveError error={error} action='complete the sample' />
          <Mtds.Flex className={'mt-8'}>
            <Mtds.Button command='close' commandfor={'complete-sample-modal'}>
              <XIcon />
              Cancel
            </Mtds.Button>
            <Mtds.Button
              data-variant='primary'
              type='submit'
              aria-busy={analysisCompleted.isPending}
              disabled={analysisCompleted.isPending}
            >
              <CheckIcon />
              Confirm
            </Mtds.Button>
          </Mtds.Flex>
        </form>
      </Mtds.Prose>
    </ModalDialog>
  )
}
